import React from "react";
import {
  FormControl,
  FormLabel,
  Box,
  Typography,
  Tooltip,
  Grid,
} from "@material-ui/core";
import { InfoOutlined as InfoOutlinedIcon } from "@material-ui/icons";
import { Error } from "../form";

export type BaseProps<V = undefined> = {
  disabled?: boolean;
  error?: Error | null;
  label?:
    | string
    | {
        text: string;
        tooltip?: string;
        caption?: string;
      };
  name: string;
  onChange?: (name: any, value: V) => void;
  required?: boolean;
  size: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
  value?: V;
  id?: number;
};

type Props = Pick<
  BaseProps,
  Exclude<keyof BaseProps, "name" | "onChange" | "value">
>;

export const Field: React.FC<Props> = (props) => {
  return (
    <FormControl component={Grid} item xs={props.size}>
      {props.label ? (
        <Box
          height={20}
          mb={0.5}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
        >
          {props.label ? (
            <FormLabel
              required={props.required}
              disabled={props.disabled}
              component={Box}
              display="flex"
              alignItems="center"
            >
              <Typography
                variant="caption"
                component={Box}
                style={{ overflowWrap: "break-word" }}
                pr={
                  typeof props.label === "string" || !props.label.tooltip
                    ? 0
                    : 0.5
                }
              >
                {typeof props.label === "string"
                  ? props.label
                  : props.label.text}
              </Typography>
              {typeof props.label !== "string" && props.label.tooltip ? (
                <Tooltip arrow title={props.label.tooltip}>
                  <InfoOutlinedIcon color="primary" fontSize="small" />
                </Tooltip>
              ) : null}
            </FormLabel>
          ) : null}
          <Error error={props.error} />
        </Box>
      ) : null}
      {typeof props.label !== "string" && props.label?.caption ? (
        <Box mb={1} pl={1} borderLeft={4} borderColor="warning.main">
          <Typography
            variant="caption"
            style={{ whiteSpace: "pre-wrap", overflowWrap: "break-word" }}
          >
            {props.label.caption}
          </Typography>
        </Box>
      ) : null}
      {props.children}
    </FormControl>
  );
};
